// 充值交易（充幣）模塊 - 繁體中文
export default {
  tabs: {
    summary: "交易匯總",
    counterparty: "交易對手",
    details: "交易詳情",
  },
  common: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    downloadFilename: "數據明細",
    loading: "拼命加載中",
    empty: "暫無數據",
    copySuccess: "複製成功",
  },
  summary: {
    columns: {
      title: "交易方向",
      totalCount: "交易次數",
      currency: "幣種",
      totalQuantity: "交易總數量",
    },
  },
  rival: {
    columns: {
      title: "交易方向",
      counterparty: "交易對手",
      totalCount: "交易次數",
      currency: "幣種",
      totalQuantity: "交易總數量",
    },
    directions: {
      ALL: "雙向",
      INFLOW: "流入",
      OUTFLOW: "流出",
    },
  },
  details: {
    columns: {
      title: "交易方向",
      counterparty: "交易對手",
      currency: "幣種",
      quantity: "交易數量",
      txTime: "交易時間",
      hash: "交易哈希",
    },
  },
};
